import { LiquidityQuote } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityQuotePage() {
  return <LiquidityQuote />;
}